import React from 'react'

export default function Tasks({ tasks }) {
  return (
    <div>
      <b>Tasks</b>
      {tasks.length > 0
        ? <ul>
            {tasks.map(({ task, subtasks }, i) => (
              <li key={i}>
                <span>{task}</span>
                <ul>
                  {subtasks.map(({ task, subtasks }, i) => (
                    <li key={i}>
                      <span>{task}</span>
                      <ul>
                        {subtasks.map(({ task }, i) => <li key={i}>{task}</li>)}
                      </ul>
                    </li>
                  ))}
                </ul>
              </li>
            ))}
          </ul>
        : <p>No tasks to display.</p>}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/Units/ManageUnit/AssessmentPlan/Tasks.js